import { Box, Button, Grid, Paper } from "@mui/material";
import { Link } from "react-router-dom";
import ContentRight from "shared/molecules/content-right";
import { makeStyles } from "@mui/styles";
import { indigo } from "@mui/material/colors";
import { StateLanguagePreferanceFilter } from "./filter";
import { TypographyHeading } from "shared/molecules/typography-layout";
import LanguagePrefDataTable from "./table/main-table";
import { useState } from "react";
import { useAppSelector } from "hooks/redux";
import NoDataFound from "shared/molecules/no-data";
import Loader from "pages/build-test/loader";
import {
  checkFeatureAccess,
  plateformConfigueUser,
} from "utils/role-restriction/helper";

const useStyles: any = makeStyles((indigoTheme) => ({
  label: {
    textDecoration: "none",
    textAlign: "center",
    color: indigo[700],
    marginLeft: "80%",
  },
  Btn: {
    backgroundColor: "#3f50b5",
    color: "white",
    width: "90px",
  },
  BtnWrapper: {
    display: "flex",
    gap: "20px",
    justifyContent: "flex-end",
    paddingTop: "10px",
    paddingBottom: "10px",
  },
}));

export const LanguagePreferance = () => {
  const [showSecondSection, setShowSecondSec] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const classes = useStyles();
  const { mainPageStateLangPrefList, loading }: any = useAppSelector(
    (state) => state.languagePreferanceSlice
  );
  const { profileData } = useAppSelector((state) => state.gmailLoginReducer);
  const { role: userRoleStr } = profileData;
  const userRole = userRoleStr?.split(",");

  const hasModificationAccess = checkFeatureAccess(
    userRole,
    plateformConfigueUser?.LANGUAGE_PREFERANCE_READ_WRITE
  );

  return (
    <div>
      <ContentRight>
        {hasModificationAccess && (
          <Link
            to="/configue/language_preferance/create"
            className={classes.label}
          >
            <Button variant="contained">Create</Button>
          </Link>
        )}
      </ContentRight>
      <TypographyHeading>Language Preference</TypographyHeading>

      {/* <Paper sx={{ mt: 2, p: 2 }}> */}
      <Box>
        <StateLanguagePreferanceFilter setShowSecondSec={setShowSecondSec} />
      </Box>
      {/* </Paper> */}
      {/* <Box
        sx={{
          overflowX: "auto",
          overflowY: "visible",
          width: "100%",
        }}
      >
        <LanguagePrefDataTable />
      </Box> */}
      {showSecondSection && loading && <Loader />}
      {showSecondSection &&
        !loading &&
        mainPageStateLangPrefList?.length > 0 && (
          <Paper sx={{ mt: "20px", p: 2 }}>
            <Box
              sx={{
                overflowX: "auto",
                overflowY: "visible",
                width: "100%",
              }}
            >
              <LanguagePrefDataTable data={mainPageStateLangPrefList} />
              {/* <LanguagePrefDataTable /> */}
            </Box>
          </Paper>
        )}
      {showSecondSection &&
        !loading &&
        mainPageStateLangPrefList?.length == 0 && (
          <NoDataFound message="No List found, Please create new Language Preference" />
        )}
    </div>
  );
};
